<template>
  <sp-button
    tag="a"
    :variant="variant"
    size="small"
    block
    :data-testid="TestId.slots.slot"
    :title="slot.visit_type_categories_description"
    :href="slot.booking_url"
  >
    <sp-icon v-if="visitTypeIcon" slot="prepend" :name="visitTypeIcon" size="small"></sp-icon>
    {{ formatStartTime(slot.start_time) }}
  </sp-button>
</template>

<script setup>
import { isValid } from "date-fns";
import { computed } from "vue";
import { formatLocalizedTime } from "#/shared/lib/helpers/localized-date";
import { TestId } from "#/test-ids";
import { parseOffsetDateTime } from "#ce/utils/offset-date";

const props = defineProps({
  entry: {
    type: Object,
    required: true,
  },
  variant: {
    type: String,
    default: "outlined",
  },
});
const slot = computed(() => props.entry);

// The field is optional on payloads assembled outside the jbuilders, and throwing here takes
// down every card in the row rather than this one slot.
const visitTypeIcon = computed(() => {
  const categories = slot.value.visit_type_categories;

  if (Array.isArray(categories) && categories.includes("video")) {
    return "video-visit-filled";
  }

  return undefined;
});

function formatStartTime(startTime) {
  const parsed = parseOffsetDateTime(startTime);

  if (!isValid(parsed)) {
    return "";
  }

  // `parsed` carries the slot's own offset, so the card shows the clinic's
  // wall-clock time rather than the visitor's.
  return formatLocalizedTime(parsed);
}
</script>

<style scoped lang="scss">
sp-button {
  --sp-comp-button-small-padding: 0;
  --sp-comp-button-font-weight: var(--sp-comp-slot-button-font-weight, var(--sp-sys-typescale-body-font-weight));
  --sp-comp-button-primary-bg-color: var(--sp-comp-slot-button-bg-color);
  --sp-comp-button-primary-hover-bg-color: var(--sp-comp-slot-button-hover-bg-color);
}
</style>
